export default __webpack_public_path__ + "static/media/check.236cc676.png";